import { Component,ViewChild } from '@angular/core';
import { NavController,ViewController,NavParams,Platform } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import { provider } from '../../../providers/provider';
import { Slides } from 'ionic-angular';
import { ProductsHorizontalPage } from '../productsHorizontal/productsHorizontal';
import { ProductsVerticalPage } from '../productsVertical/productsVertical';
import { ProductsNoImageListPage } from '../productsNoImageList/productsNoImageList';
import { productDetailPage } from '../../productDetail/productDetail';
import { CartPage } from '../../cart/cart';
import { CustomizerProvider } from '../../../providers/customizer/customizer';
import { isUndefined } from 'util';

@Component({
  selector: 'page-products-withimagelist',
  templateUrl: 'productsWithImageList.html'
})
export class ProductsWithImageList {
  @ViewChild(Slides) slides: Slides;
  url: any;
  groupId = '';
  groupContentId = '';
  viewType = '';
  group: any;
  groupContent: any;
  data: any;
  tot = 0;
  width: any;
  height: any;
  regex = /(<([^>]+)>)/ig;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public translateService: TranslateService,
              public storage: Storage,
              public viewCtrl: ViewController,
              public provider: provider,
              public customizer: CustomizerProvider,
              public platform: Platform) {
    this.url = provider.getUrl();
    this.data = provider.getMenu();
    this.group = navParams.get('group');
    this.groupId = this.group._id;
    this.groupContentId = this.group.content._id;
    this.groupContent = this.group.content;

    platform.ready().then((readySource) => {
      this.width = platform.width();
      this.height = platform.height();
    });

    // visualizzazione globale a lista o con scroll orizzontale dei prodotti
    this.viewType = this.data.settings.viewType;
  }

  getIngredients(obj) {
    let varIngr=[],ingredients=[];
    for(let j=0; j<obj.content.varIngr.length; j++) {
      for(let i=0; i<this.data.lib.length; i++) {
        if(this.data.lib[i]._id == obj.content.varIngr[j]) {
          varIngr.push(JSON.parse(JSON.stringify(this.data.lib[i])));
        }
      }
    }
    for(let j=0; j<varIngr.length;j++) {
      ingredients.push(`
      <p padding-horizontal text-center text-lowercase>
        <span [ngClass]="{allergene:${obj.content.extraProps.allergene}}" *ngIf="!last">{{provider.renderDescr(${varIngr[j]})}} | </span>
        <span [ngClass]="{allergene:${obj.content.extraProps.allergene}}" *ngIf="last">{{provider.renderDescr(${varIngr[j]})}}</span>
      </p>
      `)
    }
    return ingredients
  }

  getUrlImageTag(img) {
    if(this.data.settings.highResImages) 
      return this.url + img.img;
    else
      return this.url + img.img + '?h=56';
  }

  getUrlImage(img) {
    if (this.viewType == 'OS') {
      let imageType = this.data.settings.imageType

      if(img.extraProps.imageType !== isUndefined) 
        imageType = img.extraProps.imageType;

      if(this.data.settings.highResImages) {
        return this.url + img.img;
      } else {
        switch(imageType) {
          case 'S':
            return this.url + img.img + '?h=' + Math.floor(this.height/4);
          case 'M':
            return this.url + img.img + '?h=' + Math.floor(this.height/3);
          case 'L':
            return this.url + img.img + '?h=' + Math.floor(this.height/2);
        }
      }  
    }
    else {
      if(this.data.settings.highResImages) {
        return this.url + img.img;
      } else {
        return this.url + img.img + '?h=56&w=56';
      } 
    }
  }

  showProducts(group) {
    //pubblicità
    let isAdv = this.data.menu.righe.filter((element) => element.parent == group._id);
    if (isAdv.length == 0) return;
    
    if(group.viewType == 'vertical') 
      this.navCtrl.push(ProductsVerticalPage, { group: group });
    else if(group.viewType == 'horizontal') 
      this.navCtrl.push(ProductsHorizontalPage, { group: group });
    else if(group.viewType == 'image-list') 
      this.navCtrl.push(ProductsWithImageList, { group: group });
    else
      this.navCtrl.push(ProductsNoImageListPage, { group: group });
  }
  showProduct(product) {
    this.navCtrl.push(productDetailPage, { product: product });
  }
  cart() {
    this.navCtrl.push(CartPage);
  }

  ionViewDidEnter() {
    this.tot = this.provider.showTotal();
  }

  ionViewDidLoad() {
  }

  // modalità sfoglia menu con scroll

  getImg(img) {
    return 'assets/ALLERGENI/' + img + '.png';
  }

  // check for extended description
  hasExtendedDescription(group) : Boolean {
    return (group.descrizioneEstesa != undefined && group.descrizioneEstesa[0] != undefined && group.descrizioneEstesa[0].contenuto != '');
  }

}




// WEBPACK FOOTER //
// ./src/pages/products/productsWithImageList/productsWithImageList.ts